'use strict';

var adSelectTemplate = require('../templates/ad-select.tpl');

var Select = function(options) {
	this.className = options.className;
	this.list = options.list;
	this.changeFunction = options.changeFunction;
};

Select.prototype.render = function(config, deps) {
	if (!this.list) return '';
	var _ = deps.underscore;
	var selectTemplate = _.template(adSelectTemplate);
	return selectTemplate({
		className: this.className,
		list: this.list,
		changeFunction: this.changeFunction
	});
};

module.exports = Select;



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/views/Select.js
// module id = 22
// module chunks = 0